// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .search-tree-container[data-v-e50b63b6] {\n  padding-left: 10px !important;\n  margin-bottom: 45px !important;\n}\n.loss-reason-modal[data-v-e50b63b6] {\n  height: 400px !important;\n}\n", ""]);
// Exports
module.exports = exports;
